const EMBED_BASE_URL = 'https://www.affogata.com/';

export default (embed, source) => {
    const url = new URL(EMBED_BASE_URL);

    url.searchParams.set('affx_embed', embed);

    if (source) {
        url.searchParams.set('source', source);
    }

    return url.toString();
};